import React from "react";

export default function LineSegmentIcon(props: any) {
  return (
    <svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.3581 7.85606C19.9583 8.25585 19.4402 8.51588 18.8807 8.59747C18.3213 8.67906 17.7504 8.57784 17.2531 8.30887L8.80906 16.7529C9.04061 17.1812 9.14852 17.6654 9.12072 18.1514C9.09292 18.6374 8.9305 19.1061 8.65163 19.5052C8.37275 19.9042 7.98841 20.2178 7.54154 20.411C7.09467 20.6042 6.60289 20.6693 6.12116 20.599C5.63943 20.5287 5.18672 20.3259 4.81364 20.0132C4.44056 19.7004 4.1618 19.2901 4.00852 18.828C3.85523 18.3659 3.83346 17.8703 3.94564 17.3966C4.05782 16.9229 4.29952 16.4897 4.64374 16.1454C5.04351 15.7456 5.56168 15.4856 6.12114 15.404C6.6806 15.3224 7.25144 15.4236 7.74874 15.6926L16.1928 7.24855C15.9613 6.82032 15.8533 6.33613 15.8811 5.8501C15.9089 5.36406 16.0714 4.89534 16.3502 4.4963C16.6291 4.09726 17.0135 3.78364 17.4603 3.59047C17.9072 3.39731 18.399 3.33222 18.8807 3.40248C19.3624 3.47274 19.8151 3.67558 20.1882 3.98833C20.5613 4.30108 20.8401 4.71142 20.9933 5.17348C21.1466 5.63555 21.1684 6.13114 21.0562 6.60487C20.944 7.0786 20.7023 7.5118 20.3581 7.85606Z"
        fill="#FF752C"
      />
    </svg>
  );
}
